import ResultBlock from './ResultBlock'
export default ResultBlock
